import { combineEpics } from "redux-observable";
import { epicQuestFinish } from "../epics/epicQuestFinish";
import { epicQuestOpen } from "../epics/epicQuestOpen";
import { epicQuestSelect } from "../epics/epicQuestSelect";
import { epicQuestSkip } from "../epics/epicQuestSkip";
import { epicQuestUpdate } from "../epics/epicQuestUpdate";
import { epicQuestUpdateSelectedQuest } from "../epics/epicQuestUpdateSelectedQuest";
import { epicQuestVisited } from "../epics/epicQuestVisited";
export var epicQuests = combineEpics(epicQuestFinish, epicQuestSkip, epicQuestSelect, epicQuestOpen, epicQuestUpdate, epicQuestVisited, epicQuestUpdateSelectedQuest);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/epicQuests.ts
// module id = 1965
// module chunks = 3